const ExpoBlob = Blob;
export { ExpoBlob as Blob };
